import { useQuery } from "@tanstack/react-query";
import {
  JobTaskDetailSchema,
  mvpApiGetNextPendingJobTask,
} from "@augmodo/lebron-browser-client";

/**
 * React Query hook to fetch the next pending task for a given job
 */
export function useNextPendingTask(
  jobId: string | undefined,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: ["nextPendingTask", jobId],
    queryFn: async (): Promise<JobTaskDetailSchema> => {
      const response = await mvpApiGetNextPendingJobTask({
        path: {
          job_id: jobId || "",
        },
      });

      if (response.error) {
        throw new Error(`Failed to fetch next pending task: ${response.error}`);
      }

      return response.data as JobTaskDetailSchema;
    },
    enabled: !!jobId && enabled,
    // A 404 means the job has no claimable pending task right now; retrying
    // doesn't help and the call has a side effect (claims the task).
    retry: false,
  });
}
